import React from 'react';

import { Link } from 'react-router-dom';
import Footer from '../../components/footer';
const Contact = () => {

    return (
        <>
            <div className='App other-page-top my-credits-mobile'>
                <div className="AppContent BreakPointContainer">
                    <div>
                        <div className="StaticPageContent">
                            <div className="StaticPages p-t-25 p-b-25">
                                <div className="layout">

                                    <div className="flex xs12 sm12">
                                        <div className="m-t-25 return-ex">
                                            <div className="flex xs12 sm9">
                                                <div className="m-t-25">
                                                    <h4>For Order Inquiries</h4>
                                                    <p className="m-b-6 p3">Our customer care team is available on Monday - Friday, 10am - 6pm | Saturday 1-6pm IST.:</p>
                                                    <p className="m-b-10 p3">1. Size and fit advice</p>
                                                    <p className="m-b-10 p3">2. Detailed product information</p>
                                                    <p className="m-b-10 p3">3. Delivery related queries</p>
                                                    <p className="m-b-10 p3">4. Exchange and return queries</p>
                                                    <p className="m-b-10 p3">5. Placing orders</p>
                                                   
                                                    <h4>Call +91- 9147072827 </h4>
                                                    <h4>For Style Advice</h4>
                                                    <p className="m-b-10 p3">Our expert fashion advisors are here to help you:</p>
                                                    <p className="m-b-10 p3">1. Find the perfect party outfit</p>
                                                    <p className="m-b-10 p3">2. Refresh your working wardrobe</p>
                                                    <p className="m-b-10 p3">3. Choose the new season's must-haves</p>
                                                    <p className="m-b-10 p3">4. Select hand-picked gifts for your family or friends</p>
                                                    
                                                    <h4>Call +91- 9147072827 </h4>
                                                    <h4>Press and media</h4>
                                                   
                                                    <h4>Suppliers and designers</h4>
                                                    
                                                    <h4>Potential contributors - photographers, fashion journalists or editors</h4>
                                                   
                                                    <p>&nbsp;</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Contact